var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"header_social"},_vm._l((_vm.socialMenus),function(menu,key){return _c('li',{key:key},[_c('a',{attrs:{"href":menu.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{class:menu.cssClass})])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe5b208","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/TopSocialMenu.vue
// module id = null
// module chunks = 